//断约客户信息列表

<template>
  <div class="threeLevelMain">
    <!-- 头部查询区域 -->
    <div class="queryBox clearfix">
      <div class="query_row" v-show="!isFoldQuery">
        <!-- <p class="rpw_title">筛选条件</p> -->
        <div class="scan_box">
          <span class="sp_scan">公司名称：</span>
          <el-input
            class="ip_uniform_style"
            @input="searchBtn"
            v-model="getTabData.corporate_name"
            placeholder="全部"
            size="mini"
          ></el-input>
        </div>
        <div class="scan_box">
          <span class="sp_scan">品牌名称：</span>
          <el-input
            @input="searchBtn"
            class="ip_uniform_style"
            v-model="getTabData.brand_name"
            placeholder="请输入品牌"
            size="mini"
          ></el-input>
        </div>
        <div class="scan_box">
          <span class="sp_scan">合作性质：</span>
          <el-select
            v-model="getTabData.properties"
            @change="searchBtn"
            placeholder="全部"
            size="mini"
            class="ip_uniform_style"
            clearable
          >
            <el-option
              v-for="item in khlxOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="scan_box">
          <span class="sp_scan">运营分部：</span>
          <el-select
            clearable
            @change="searchBtn"
            v-model="getTabData.group"
            placeholder="全部"
            size="mini"
            class="ip_uniform_style"
          >
            <el-option
              v-for="item in operationDepartmentOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="scan_box">
          <span class="sp_scan">店长：</span>
          <el-select
            v-model="getTabData.assign_id"
            @change="searchBtn"
            placeholder="全部"
            size="mini"
            filterable
            class="ip_uniform_style"
            clearable
          >
            <el-option
              v-for="item in operatePersonOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div class="scan_box">
          <span class="sp_scan">组长：</span>
          <el-select
            v-model="getTabData.assign_name_leader"
            @change="searchBtn"
            placeholder="全部"
            size="mini"
            filterable
            class="ip_uniform_style"
            clearable
          >
            <el-option
              v-for="item in groupLeaderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div class="scan_box">
          <span class="sp_scan">销售：</span>
          <el-select
            @change="searchBtn"
            v-model="getTabData.sale_id"
            placeholder="全部"
            size="mini"
            class="ip_uniform_style"
            filterable
            clearable
          >
            <el-option
              v-for="item in salePersonOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="scan_box" v-if="jurisdiction">
          <span class="sp_scan">销售主管：</span>
          <el-select
            @change="salesChange"
            v-model="supervisorId"
            placeholder="全部"
            size="mini"
            class="ip_uniform_style"
            clearable
          >
            <el-option label="张正松" value="3"></el-option>
            <el-option label="金扬" value="32"></el-option>
            <el-option label="张雯洁" value="5"></el-option>
          </el-select>
        </div>

        <div class="scan_box">
          <span class="sp_scan">类目：</span>
          <el-select
            v-model="getTabData.category"
            clearable
            @change="searchBtn"
            placeholder="全部"
            size="mini"
            class="ip_uniform_style"
          >
            <el-option
              v-for="item in categoryOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div class="scan_box">
          <span class="sp_scan" style="line-height: 1">实际服务金额：</span>
          <div class="cooperation_amount" style="margin-right: 10px">
            <el-input
              class="ip_scan"
              @input="searchBtn"
              v-model="getTabData.contract_amount_state"
              placeholder=""
              size="mini"
              style="width: 110px"
            ></el-input>
            <span style="margin: 0 10px">~</span>
            <el-input
              class="ip_scan"
              @input="searchBtn"
              v-model="getTabData.contract_amount_end"
              placeholder=""
              size="mini"
              style="width: 110px"
            ></el-input>
          </div>
        </div>

        <div class="scan_box">
          <span class="sp_scan">是否分期：</span>
          <el-select
            v-model="getTabData.payment_method"
            clearable
            @change="searchBtn"
            size="mini"
            class="ip_uniform_style"
          >
            <el-option label="是" value="2"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </div>
        <div class="scan_box">
          <span class="sp_scan">incall：</span>
          <el-select
            v-model="getTabData.incall"
            @change="searchBtn"
            clearable
            size="mini"
            class="ip_uniform_style"
          >
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </div>

        <div class="scan_box">
          <span class="sp_scan">主要产品：</span>
          <el-input
            class="ip_uniform_style"
            @input="searchBtn"
            clearable
            v-model="getTabData.main_products"
            size="mini"
          ></el-input>
        </div>

        <div class="block scan_box">
          <span class="sp_scan">签订时间：</span>
          <el-date-picker
            class="date_range"
            v-model="valueDate"
            :editable="false"
            type="monthrange"
            align="right"
            unlink-panels
            range-separator="-"
            size="mini"
            value-format="yyyy-MM-dd"
            @change="valueDateChange('contact')"
            :picker-options="monthPickerOptions"
          >
          </el-date-picker>
        </div>

        <div class="block scan_box">
          <span class="sp_scan">到期时间：</span>
          <el-date-picker
            v-model="dqsjDate"
            class="date_range"
            :editable="false"
            type="monthrange"
            align="right"
            unlink-panels
            range-separator="-"
            size="mini"
            value-format="yyyy-MM-dd"
            @change="dueTimeChange('due')"
            :picker-options="monthPickerOptions"
          >
          </el-date-picker>
        </div>

        <div class="scan_box">
          <span class="sp_scan">退款情况：</span>
          <el-select
            v-model="getTabData.is_refund"
            clearable
            @change="searchBtn"
            size="mini"
            class="ip_uniform_style"
          >
            <el-option label="无退款" value="0"></el-option>
            <el-option label="有退款" value="1"></el-option>
          </el-select>
        </div>

        <!-- 购买人员用于查看所有客户信息（只读） -->
        <div class="scan_box" v-if="userId == '173'">
          <span class="sp_scan">查看状态：</span>
          <el-select
            v-model="getTabData.is_Purchase"
            @change="searchBtn"
            clearable
            size="mini"
            class="ip_uniform_style"
          >
            <el-option label="默认" value=""></el-option>
            <el-option label="所有客户信息（只读）" value="1"></el-option>
          </el-select>
        </div>
      </div>
      <div class="btn_area_out" v-show="!isFoldQuery">
        <!-- <el-button 
            size="mini" 
            @click="searchBtn">查询</el-button> -->
        <el-button
          size="mini"
          @click="resetSearch"
          type="primary"
          icon="el-icon-refresh"
          >重置筛选</el-button
        >
        <el-button
          size="mini"
          v-if="jurisdiction"
          @click="exportHandle"
          icon="el-icon-download"
          >导出数据</el-button
        >
      </div>
      <!-- 折叠区域 -->
      <div class="fold_btn">
        <!-- 展开 -->
        <div
          class="f_open_area little_hands"
          @click="isFoldQuery = !isFoldQuery"
          v-show="!isFoldQuery"
        >
          <el-button
            type="text"
            icon="el-icon-arrow-up"
            class="btn_icon_s"
          ></el-button>
          <p class="fold_content">收起</p>
        </div>
        <!-- 折叠 -->
        <div class="f_fold_area" v-show="isFoldQuery">
          <h3>筛选区域</h3>
          <div
            class="f_f_content little_hands"
            @click="isFoldQuery = !isFoldQuery"
          >
            <p class="fold_content">展开</p>
            <el-button
              type="text"
              icon="el-icon-arrow-down"
              class="btn_icon_s"
            ></el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="account-view">
      <div class="ac-result">
        <span class="label">总金额：</span>
        <!-- <countTo class="cn_num" :startVal='0' :endVal='zje || 0' :duration='2000'></countTo> -->
        <span class="cn_num">{{ zje || 0 }}</span>
      </div>
      <div class="ac-result">
        <span class="label">总数量：</span>
        <!-- <countTo class="cn_num" :startVal='0' :endVal='zsl || 0' :duration='1000'></countTo> -->
        <span class="cn_num">{{ zsl || 0 }}</span>
      </div>
    </div>

    <!-- 内容 -->
    <tablePageComp
      :columnsList="columnsList"
      :dataList="dataList"
      :orderNumConfig="{}"
      :getDataConfig="dataQueryFunc()"
      :updateDataSignObj="{
        updateDataTag,
        resetPageNum,
      }"
      @setResetPageNum="setRPN"
      :totalCount="totalCount"
      v-loading="loading"
      :recalculateTag="isFoldQuery"
    >
      <!-- 编号 -->
      <!-- 利用插槽 -->
      <el-table-column slot="id" width="80" align="center" label="客户编号">
        <template slot-scope="scope">
          <div>{{ scope.row.customer_id }}</div>
        </template>
      </el-table-column>

      <el-table-column
        slot="corporate_name"
        align="center"
        label="公司名称"
        width="120"
      >
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            @click="handleDetail(scope.row)"
            >{{ scope.row.corporate_name }}</el-link
          >
        </template>
      </el-table-column>

      <!-- 品牌名称 -->
      <el-table-column
        slot="brand_name"
        width="149"
        align="center"
        label="品牌名称"
      >
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            @click="handleDetail(scope.row)"
            >{{ scope.row.brand_name }}</el-link
          >
        </template>
      </el-table-column>

      <!-- 签订时间 -->
      <el-table-column
        slot="cooperation_time"
        width="100"
        align="center"
        label="签订时间"
        sortable
        prop="cooperation_time"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.cooperation_time.split(" ")[0] }}</div>
        </template>
      </el-table-column>

      <!-- 到期时间 -->
      <el-table-column
        slot="due_time"
        width="100"
        align="center"
        label="到期时间"
        sortable
        prop="due_time"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.due_time.split(" ")[0] }}</div>
        </template>
      </el-table-column>

      <!-- 合同金额 -->
      <el-table-column
        slot="contract_amount"
        width="100"
        align="center"
        label="合同金额"
        v-if="getTabData.is_Purchase == ''"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.contract_amount }}</div>
        </template>
      </el-table-column>

      <!-- 实际服务金额 -->
      <el-table-column
        slot="cooperation_amount"
        width="100"
        align="center"
        label="实际服务金额"
        v-if="getTabData.is_Purchase == ''"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.cooperation_amount }}</div>
        </template>
      </el-table-column>

      <!-- 品牌类型 -->
      <el-table-column slot="category" width="100" align="center" label="类目">
        <template slot-scope="scope">
          <div>{{ scope.row.category }}</div>
        </template>
      </el-table-column>

      <el-table-column
        slot="payment_method"
        width="80"
        align="center"
        label="是否分期"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.payment_method == '1'" class="fontColor_success">
            否
          </div>
          <div v-else class="fontColor_theme">分期</div>
        </template>
      </el-table-column>

      <el-table-column
        slot="properties"
        width="80"
        align="center"
        label="合作性质"
      >
        <template slot-scope="scope">
          <div class="fontColor_theme">
            {{
              scope.row.properties == 1
                ? "新签"
                : scope.row.properties == 2
                ? "续签"
                : scope.row.properties == 3
                ? "新签新增"
                : "续签新增"
            }}
          </div>
        </template>
      </el-table-column>

      <!-- 最近沟通时间 -->
      <el-table-column
        slot="touch_time"
        width="180"
        align="center"
        label="最近沟通时间"
        sortable
        prop="touch_time"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.touch_time == "" ? "未沟通" : scope.row.touch_time }}
          </div>
        </template>
      </el-table-column>

      <!-- 波罗蜜 -->
      <el-table-column
        slot="boluomi"
        width="100"
        align="center"
        label="波罗蜜"
        v-if="jurisdiction"
      >
        <template slot-scope="scope">
          {{ scope.row.boluomi }}
          <el-popover
            placement="top-start"
            width="200"
            trigger="manual"
            v-model="scope.row.boluomiVisible"
          >
            <div>
              <el-input
                style="margin-bottom: 10px"
                v-model="scope.row.boluomi"
                size="mini"
                placeholder="请输入内容"
              ></el-input>
            </div>
            <div style="text-align: right; margin: 0">
              <el-button
                size="mini"
                type="text"
                @click="scope.row.boluomiVisible = false"
                >取消</el-button
              >
              <el-button
                type="primary"
                size="mini"
                @click="remarkEditConfirm(scope.row, scope.$index)"
                >确定</el-button
              >
            </div>
            <i
              class="el-icon-edit"
              slot="reference"
              @click="remarkEditClick(scope.$index)"
            ></i>
          </el-popover>
        </template>
      </el-table-column>

      <!-- 详情 -->
      <el-table-column
        slot="info_detail"
        align="center"
        label="客户信息详情"
        width="105"
      >
        <template slot-scope="scope">
          <el-button
            class="tableBtn_width"
            type="primary"
            plain
            size="mini"
            @click="handleDetail(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>

      <!-- 店长 -->
      <el-table-column
        slot="assign_name"
        width="80"
        align="center"
        label="店长"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.name }}</div>
        </template>
      </el-table-column>

      <el-table-column slot="group_name" width="80" align="center" label="组长">
        <template slot-scope="scope">
          <div>{{ scope.row.assign_name_leader }}</div>
        </template>
      </el-table-column>

      <el-table-column slot="sale_id" align="center" label="销售" width="80">
        <template slot-scope="scope">
          <div>
            {{ scope.row.sale_name }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        slot="assign_sale"
        align="center"
        label="指派销售"
        width="120"
        v-if="jurisdiction"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            size="mini"
            @click="openAssignDia(scope.row)"
            >指派销售
          </el-button>
        </template>
      </el-table-column>

      <el-table-column slot="incall" width="80" align="center" label="incall">
        <template slot-scope="scope">
          <div v-if="scope.row.incall == '1'" class="fontColor_success">是</div>
          <div v-if="scope.row.incall == '0'" class="fontColor_theme">否</div>
          <div v-if="scope.row.incall == ''" class="fontColor_info">未确定</div>
        </template>
      </el-table-column>

      <el-table-column
        slot="is_contract"
        align="center"
        label="是否断约"
        width="50"
      >
        <template slot-scope="scope">
          <div
            :class="
              scope.row.is_contract == '0'
                ? 'fontColor_theme'
                : 'fontColor_danger'
            "
          >
            {{ scope.row.is_contract == "0" ? "否" : "是" }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        slot="relieve_break_contract"
        align="center"
        label="操作"
        v-if="jurisdiction"
        width="150"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="insertcontract(scope.row)"
            class="fontColor_theme"
            icon="el-icon-setting"
            >解除断约</el-button
          >
          <el-button
            type="text"
            @click="deleteInfo(scope.row.customer_id)"
            icon="el-icon-delete"
            class="fontColor_danger"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </tablePageComp>

    <!-- 总数量和总金额统计 -->
    <!-- <div class="totalAmount">
        <p>总金额：<span>{{zje == ''? 0 : zje}}.00 元</span></p>
        <p>总数量：<span>{{zsl}}</span></p>
      </div> -->

    <el-dialog title="客户类型确认" :visible.sync="dialogVis" width="300px">
      <div style="text-align: center">
        <el-select v-model="reForm.customerType">
          <el-option label="历史签约客户" value="0"></el-option>
          <el-option label="提前对接客户" value="2"></el-option>
        </el-select>
      </div>
      <span slot="footer">
        <el-button type="primary" size="small" @click="confirmType"
          >确认</el-button
        >
        <el-button @click="dialogVis = false" size="small">取消</el-button>
      </span>
    </el-dialog>

    <DetailContract :detailConfig="detailConfig"></DetailContract>

    <el-dialog title="指派销售" :visible.sync="assignVisible" width="500px">
      <el-form label-width="100px">
        <el-form-item label="选择销售">
          <el-select v-model="assignForm.sale_id" filterable>
            <el-option
              v-for="item in salePersonOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="assignVisible = false" :loading="btnLoading"
          >取消</el-button
        >
        <el-button type="primary" @click="assignHandle()" :loading="btnLoading">
          确定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
import utils from "@/libs/utils.js";
import moment from "moment";
import countTo from "vue-count-to";
import options from "@/libs/common.js";
export default {
  components: {
    countTo,
  },

  data() {
    let cp = utils.sessionGetStore("breakContractInfo");
    cp = cp == null ? 1 : cp;

    return {
      isFoldQuery: false,
      monthPickerOptions: options.monthPickerOptions,
      department: utils.sessionGetStore("department"),
      // currentPage: Number(cp),
      valueDate: [], //签订日期区间
      dqsjDate: [], //到期时间区间
      cnOption: [
        {
          value: "",
          label: "全部",
        },
      ], //公司名选项

      //表格内容相关
      loading: false, //表格内容加载中
      dataList: [], //表格数据列表
      //列的数据 插槽站位
      columnsList: [
        // {
        //     label:"编号",
        //     slotName:"id"
        // },
        {
          label: "公司名称",
          slotName: "corporate_name",
        },
        {
          label: "品牌名称",
          slotName: "brand_name",
        },
        {
          label: "退款情况",
          prop: "is_refund",
          formatter: (val) => (val == "0" ? "无退款" : "有退款"),
        },
        {
          label: "断约原因",
          prop: "details",
          width: 200,
          tooltip: true,
        },
        {
          label: "签订时间",
          slotName: "cooperation_time",
        },
        {
          label: "到期时间",
          slotName: "due_time",
        },
        {
          label: "合同金额",
          slotName: "contract_amount",
        },
        {
          label: "实际服务金额",
          slotName: "cooperation_amount",
        },
        {
          label: "类目",
          slotName: "category",
        },
        {
          label: "主要产品",
          prop: "main_products",
        },
        {
          label: "是否分期",
          slotName: "payment_method",
        },
        {
          label: "合作性质",
          slotName: "properties",
        },
        // {
        //   label:"波罗蜜",
        //   slotName:"boluomi"
        // },
        {
          label: "店长",
          prop: "assign_name",
        },
        {
          label: "组长",
          slotName: "group_name",
        },
        {
          label: "销售",
          slotName: "sale_id",
        },
        {
          slotName: "assign_sale",
        },
        {
          label: "incall",
          slotName: "incall",
        },

        // {
        //   label:"是否断约",
        //   slotName:'is_contract'
        // },

        // {
        //   label: "最近沟通时间",
        //   slotName: "touch_time",
        // },
        // {
        //   label:'联系人',
        //   prop:'contacts'
        // },
        // {
        //   label:'职务',
        //   prop:'contacts_post'
        // },
        // {
        //   label:'联系人电话',
        //   prop:'contacts_phone',
        //   width:120
        // },
        // {
        //   label:"客户信息详情",
        //   slotName:"info_detail"
        // },
        {
          label: "断约操作",
          slotName: "relieve_break_contract",
        },
      ],
      // 主动跟新数据标记
      updateDataTag: false,
      resetPageNum: true, // 是否重置页面
      // 数据总条数
      totalCount: 0,
      userId: "", //用户id
      userName: "", //用户名
      getTabData: {
        start: "",
        end: "",
        corporate_name: "", //公司名 默认空
        due_time_start: "", //到期开始时间
        due_time_end: "", // 到期结束时间
        brand_name: "", // 品牌名
        assign_id: "", // 店长
        assign_name_leader: "", // 组长
        properties: "", // 客户类型
        contract_amount_state: "", // 合同金额区间开始
        contract_amount_end: "", // 合同金额结束
        category: "", //类目
        is_Purchase: "",
        is_refund: "", // 是否退款（0否1是）
        group: "", //运营一部：静微、聂敏、小平；二部：灶丽、夏娇
      }, //表格数据查询条件
      supervisorId: "",
      // 客户类型选项
      khlxOption: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "新签",
        },
        {
          value: 2,
          label: "续签",
        },
        {
          value: 3,
          label: "新签新增",
        },
        {
          value: 4,
          label: "续签新增",
        },
      ],

      // 沟通小记数据
      dialogVisible: false, //新建沟通小记对话框是否显示
      touchForm: {
        complaint: "",
        id: "", //客户编号
        user_name: "", //操作人
        contact_Records: "", //沟通小记
        contact_meth: "", //沟通方式
        remarks: "", //备注
        to_examine: "", //审核
        complaint: "", //投诉
      },
      touchRules: {
        //验证规则
        contact_Records: [
          { required: true, message: "请填写沟通小记", trigger: "change" },
        ],
        contact_meth: [
          { required: true, message: "请填写沟通方式", trigger: "change" },
        ],
        complaint: [],
        id: [],
        user_name: [],
        remarks: [],
        to_examine: [],
        complaint: [],
      },

      // 指派客户
      assignVisible: false, // 对话框显示
      assignForm: {
        // 指派客户表单
        id: "", //客户编号
        assign_id: "", //被指派店长id
        name: "", //客户名称
        assign_id_leader: "", // 指派组长id
        sale_id: "",
      },
      assignRules: {
        //验证规则
        id: [
          { required: true, message: "请填写客户编号", trigger: "change" },
          { type: "number", message: "客户编号必须为数字" },
        ],
        assign_id: [
          { required: true, message: "请选择店长", trigger: "change" },
        ],
      },

      jurisdiction: true, //权限 0:true    1,2:false

      zje: "", //总金额
      zsl: "", //总数量
      dialogVis: false,
      reForm: {
        customerType: "", // 解除断约客户类型
        targetId: "",
        customer_file_id: "",
      },

      // 详情查看
      detailConfig: {
        showSign: 0,
        contractProp: null,
      },

      btnLoading: false,
    };
  },
  computed: {
    salePersonOptions() {
      return this.$store.getters.salePersonOptions;
    },
    groupLeaderOptions() {
      return this.$store.getters.groupLeaderOptions;
    },
    operatePersonOptions() {
      return this.$store.getters.operatePersonOptions;
    },
    categoryOptions() {
      return this.$store.getters.categoryOptions;
    },
    operationDepartmentOptions() {
      return this.$store.state.commonOptions.operationDepartmentOptions;
    },
  },
  methods: {
    assignHandle() {
      this.btnLoading = true;
      api
        .saleAssign({ ...this.assignForm, up_user: this.userId })
        .then((res) => {
          // console.log(res)
          utils.notificationInfo("提示", "指派成功", "success");
          // 主动更新数据标记---更新
          this.updateDataTag = !this.updateDataTag;
          this.resetPageNum = false;
          // 重置表单
          this.assignVisible = false;
        })
        .catch((error) => {
          console.log(error);
          utils.notificationInfo("提示", "指派失败", "error");
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    openAssignDia(data) {
      this.assignForm = {
        work_order_id: data.work_order_id,
        name: data.corporate_name,
        customer_id: data.customer_id,
        id: data.id,
        sale_id: data.sale_id,
      };
      this.assignVisible = true;
    },
    setRPN(e) {
      this.resetPageNum = e;
    },
    //  导出列表
    exportHandle() {
      let paramObj = {
        id: this.userId,
        is_contract: 1,
      };
      const loading = this.$loading({
        lock: true,
        text: "正在导出",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      api
        .exportBreakContract(paramObj)
        .then((res) => {
          loading.close();
          utils.downloadFile(res);
        })
        .catch((error) => {
          console.log(error);
          loading.close();
          this.$message.error("导出失败");
        });
    },
    //  删除断约客户
    deleteInfo(id) {
      this.$confirm(`是否确认删除？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api
            .deleteBreakContract(id)
            .then((res) => {
              utils.notificationInfo("提示", "删除成功", "success");
              // 内容更新
              this.updateDataTag = !this.updateDataTag;
              this.resetPageNum = false;
            })
            .catch((error) => {
              console.log(error);
              utils.notificationInfo("提示", "删除失败", "error");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    // 客户断约状态操作-----解除断约
    insertcontract(data) {
      this.$confirm(
        `是否确认解除 ${data.corporate_name} 的断约状态？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        },
      )
        .then(() => {
          this.dialogVis = true;
          this.reForm.targetId = data.customer_id;
          this.reForm.customer_file_id = data.customer_file_id;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    confirmType() {
      if (!this.reForm.customerType) {
        this.$message.warning("请选择客户类型");
        return;
      }
      let paramObj = {
        // id: data.id,
        // id: data.customer_id,
        // is_contract: '0',
        // type: '9',
        up_user: this.userId,

        is_contract: this.reForm.customerType,
        id: this.reForm.targetId,
        customer_file_id: this.reForm.customer_file_id,
      };
      // 新加字段 type 9----- 断约客户签约申请工单---2020-11-03
      // 解除断约不走工单，直接返回客户到原列表 在进行签约申请  2022-06-13
      api
        .relieveContract(paramObj)
        .then((res) => {
          // console.log(res)
          if (res.data.code == 0) {
            utils.notificationInfo("提示", "解除断约操作成功", "success");
            // 更新
            this.updateDataTag = !this.updateDataTag;
            this.resetPageNum = false;
            this.dialogVis = false;
          }
        })
        .catch((error) => {
          console.log(error);
          utils.notificationInfo("提示", "解除断约操作失败", "warning");
        });
    },
    salesChange() {
      this.getTabData.id = this.supervisorId;
      this.searchBtn();
    },
    valueDateChange() {
      if (this.valueDate && this.valueDate.length > 0) {
        this.getTabData.start = this.valueDate[0];
        this.getTabData.end = moment(this.valueDate[1])
          .endOf("month")
          .format("yyyy-MM-DD");
      } else {
        this.getTabData.start = "";
        this.getTabData.end = "";
      }
      this.searchBtn();
    },
    dueTimeChange() {
      if (this.dqsjDate && this.dqsjDate.length > 0) {
        this.getTabData.due_time_start = this.dqsjDate[0];
        this.getTabData.due_time_end = moment(this.dqsjDate[1])
          .endOf("month")
          .format("yyyy-MM-DD");
      } else {
        this.getTabData.due_time_start = "";
        this.getTabData.due_time_end = "";
      }
      this.searchBtn();
    },
    searchBtn(e) {
      // if(e == 'contact' && this.valueDate && this.valueDate.length > 0) {
      //   this.getTabData.start = this.valueDate[0]
      //   this.getTabData.end = moment(this.valueDate[1]).endOf('month').format('yyyy-MM-DD')
      // } else {
      //   this.getTabData.start = ''
      //   this.getTabData.end = ''
      // }
      // if(e == 'due' && this.dqsjDate) {
      //   this.getTabData.due_time_start = this.dqsjDate[0]
      //   this.getTabData.due_time_end = moment(this.dqsjDate[1]).endOf('month').format('yyyy-MM-DD')
      // } else {
      //   this.getTabData.due_time_start = ''
      //   this.getTabData.due_time_end = ''
      // }

      utils.debounceFunc(() => {
        this.updateDataTag = !this.updateDataTag;
      });
    },

    //重置查询
    resetSearch() {
      this.valueDate = [];
      this.dqsjDate = [];
      Object.keys(this.getTabData).forEach((key) => {
        this.getTabData[key] = "";
      });
      this.getTabData.id = this.userId;
      this.supervisorId = "";
      this.updateDataTag = !this.updateDataTag;
    },

    //表格数据获取
    dataQueryFunc() {
      //查询条件
      let paramObj = {};
      Object.keys(this.getTabData).forEach((key) => {
        if (this.getTabData[key] != "") {
          paramObj[key] = this.getTabData[key];
        }
      });
      paramObj.is_contract = "1"; // 断约

      return {
        // apiName:'getBreakContractInfo',
        apiName: "getCustomersData",
        paramObj: paramObj,
        success: function (response, callBack) {
          this.zje = Number(response.data.data.contract_amount_Count);
          this.zsl = Number(response.data.data.totalCount);

          // 表格组件中，调用接口后的成功回调中调用该方法
          let records = response.data.data.list;
          let arr = [];
          for (let i = 0; i < records.length; i++) {
            let obj = records[i];
            //全部表头 和接口返回字段一一对应
            let standardObj = {
              corporate_name: "公司名称",
              id: "工单编号",
              brand_name: "品牌名称",
              cooperation_time: "签订时间",
              due_time: "到期时间",
              contract_amount: "合同金额",
              category: "品牌类型",
              touch_time: "最近沟通时间",
              due_time: "",
              boluomi: "波罗蜜",
            };
            for (let key in standardObj) {
              if (obj[key] == null || obj[key] == undefined) {
                obj[key] = "";
              }
            }

            //公司名称选项
            let addName = true; //是否添加公司名
            this.cnOption.forEach((item) => {
              if (item.label == records[i].corporate_name) {
                addName = false;
              }
            });
            if (addName) {
              this.cnOption.push({
                value: records[i].corporate_name,
                label: records[i].corporate_name,
              });
            }

            arr.push(obj);
          }
          // 数据列表---更新
          this.dataList = arr;
          // 数据总条数---更新
          this.totalCount = response.data.data.totalCount; //接口返回的数据总条数

          if (callBack) {
            callBack();
          }
        }.bind(this),
        failed: function (error, callBack) {
          // 回调函数
          if (callBack) {
            callBack();
          }
        },
      };
    },

    //跳转详情页
    //
    //
    goToDetail(row) {
      if (this.getTabData.is_Purchase) {
        return;
      }
      // console.log('detail',row)
      let r = this.$router.resolve({
        path: "/index/customerManage/customerInfoDetail",
        query: {
          orderId: row.customer_id,
          corporate_name: row.corporate_name, //公司名
          sign: 3, // 断约客户标识
        },
      });
      window.open(r.href, "_blank");
    },
    handleDetail(row) {
      // 购买人员 只读
      if (this.getTabData.is_Purchase) {
        return;
      }
      this.detailConfig.showSign++;
      this.detailConfig.contractProp = {
        sign: 3, // 进入详情类型标识  // 断约客户标识
        ...row,
      };
    },

    // boluomi 相关操作
    //  添加波罗蜜
    // 点击 波罗蜜的修改图标
    remarkEditClick(index) {
      for (let i = 0; i < this.dataList.length; i++) {
        this.dataList[i].boluomiVisible = false;
      }
      this.dataList[index].boluomiVisible = true;
    },
    // 修改波罗蜜
    remarkEditConfirm(row, index) {
      // console.log(row)
      let paramObj = {
        id: row.id,
        boluomi: row.boluomi,
      };

      // boluomi 输入为空时，传递过去只能是 0
      if (row.boluomi == "") {
        paramObj.boluomi = 0;
      }
      // api
      api
        .reviseBoluomi(paramObj)
        .then((res) => {
          // console.log(res)
          this.dataList[index].boluomiVisible = false;
          this.updateDataTag = !this.updateDataTag;
          this.resetPageNum = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    //获取用户id
    this.userId = utils.sessionGetStore("user_id");
    this.userName = utils.sessionGetStore("user_name");
    this.getTabData.id = this.userId;

    // 获取权限
    let jur = utils.sessionGetStore("jurisdiction");
    this.jurisdiction =
      jur == "0" &&
      (this.userId == 1 ||
        this.userId == 2 ||
        this.department == "6" ||
        this.department == "7")
        ? true
        : false;
    // window.addEventListener('setBreakStorage',()=> {
    //     this.currentPage = Number(utils.sessionGetStore('breakContractInfo'))
    // })
  },
};
</script>

<style lang="scss" scoped>
.threeLevelMain {
  .queryBox {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    position: relative;

    // 实际服务金额
    .cooperation_amount {
      display: flex;
      align-items: center;
      justify-content: center;
      > div {
        margin: 0 !important;
      }
    }

    .activeBtn {
      position: absolute;
      top: 15px;
      right: 50px;
    }
  }

  .account-view {
    padding: 5px;
    background-color: #fff;
    display: flex;

    .ac-result {
      margin: 0 20px;
      > span {
        font-size: 14px;
      }
      .label {
        line-height: 1;
      }
      &:nth-child(2) {
        margin-left: 50px;
      }
      .cn_num {
        // color: #00B791;
        color: #0f70ee;
        font-weight: bold;
      }
    }
  }
  .totalAmount {
    position: absolute;
    width: 300px;
    // background: red;
    bottom: 25px;
    right: 20px;

    > p {
      font-size: 16px;
      font-weight: 500;
      > span {
        font-size: 16px;
        color: #409eff;
      }
    }
  }
}
</style>
